'use strict';

var generatedCraftcms = require('@liquorice/generated-craftcms');

const FIELD_BASE_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldBase on FieldInterface {
    __typename
    id
    conditions
    containerAttributes { label, value}
    cssClasses
    defaultValue
    displayName
    emailValue
    enableConditions
    enabled
    errorMessage
    handle
    inputAttributes { label, value }
    inputTypeName
    instructions
    label
    labelPosition
    matchField
    placeholder
    prePopulate
    required
    type
    typeName
    uid
    visibility
  }`);

exports.FIELD_BASE_FRAGMENT = FIELD_BASE_FRAGMENT;
